import { useToast } from "@chakra-ui/react";
import { DependencyList, useEffect } from "react";

interface UseMissingPermissionsToastOptions {
  getMissingPermissionsMessage: () => string | undefined;
  isLoading?: boolean;
  deps?: DependencyList;
}

export const useMissingPermissionsToast = ({ getMissingPermissionsMessage, isLoading = false, deps = [] }: UseMissingPermissionsToastOptions) => {
  const toast = useToast();

  useEffect(() => {
    if (isLoading) {
      return;
    }
    const missingPermissionsMessage = getMissingPermissionsMessage();
    if (missingPermissionsMessage) {
      toast.closeAll();
      toast({
        title: "You don't have permission to access the requested resource",
        description: missingPermissionsMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [isLoading, ...deps]);
};
